module.exports = __webpack_public_path__ + "images/emoji/mushroom.5e022c18d3885850205b.png";